// ============================================================
// MAIN LOOP
// ============================================================

import { resize } from './canvas.ts';
import { Game } from './Game.ts';
import { Renderer } from './Renderer.ts';
import { Input } from './Input.ts';
import { anim } from './Anim.ts';

const game = new Game();
(window as any).game = game;
(window as any).anim = anim;
const renderer = new Renderer();
const _input = new Input(game);

let lastT = performance.now();

function loop(t: number): void {
  const dt = Math.min(0.1, (t - lastT) / 1000);
  lastT = t;
  resize();
  game.update(dt);
  renderer.draw(game);
  requestAnimationFrame(loop);
}

requestAnimationFrame(loop);
